import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import icon_img from "../../images/logo.png";
import LinearProgress from "@material-ui/core/LinearProgress";
import withStyles from "@material-ui/core/styles/withStyles";

const useStyles = makeStyles((theme) => ({
  canvas: {
    minHeight: "100vh",
    width: "100vw",
    backgroundColor: "#E5E5E5",
    marginTop: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  image: {
    marginTop: 75,
    marginBottom: 20,
    marginLeft: 350,
    height: "40%",
    width: "40%",
  },
  info: {
    marginTop: 100,
    marginLeft: 10,
    textTransform: "unset !important",
  },
  progress: {
    width: "100%",
  },
}));

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 12,
  },
  colorPrimary: {
    backgroundColor: "transparent",
  },
  bar: {
    backgroundColor: "#FF0000",
  },
}))(LinearProgress);

export default function LoadingPage() {
  const classes = useStyles();
  const [progress, setProgress] = useState(0);

  //to animate the red progress bar
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);
  //to animate the red progress bar

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.canvas}>
        <img className={classes.image} src={icon_img} alt={"Virtual Patient"} />
        <Typography variant="h3" className={classes.info}>
          Loading Assets...
        </Typography>
        <BorderLinearProgress
          variant="determinate"
          value={progress}
          className={classes.progress}
        />
      </div>
    </React.Fragment>
  );
}
